import http from "@/plugins/http";
import { bytesToGB } from "@/plugins/bytesToGB";

export const state = {
  usage: {},
  start: null,
  end: null
};

export const getters = {
  usage: state => {
    return state.usage;
  },
  start: state => {
    return state.start;
  },
  end: state => {
    return state.end;
  }
};

export const mutations = {
  SET_USAGE(state, data) {
    data.totalInputOctets = bytesToGB(data.totalInputOctets, 2, 1024, "GiB");
    data.totalOutputOctets = bytesToGB(data.totalOutputOctets, 2, 1024, "GiB");
    data.totalOctets = bytesToGB(data.totalOctets, 2, 1024, "GiB");

    if (data.totalInputOctets === "NaN") data.totalInputOctets = 0;
    if (data.totalOutputOctets === "NaN") data.totalOutputOctets = 0;
    if (data.totalOctets === "NaN") data.totalOctets = 0;

    state.usage = data;
  },
  SET_DATE(state, data) {
    state.start = data.start;
    state.end = data.end;
  }
};

export const actions = {
  async getUsageReport({ dispatch, rootState, state }) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let payload = {
        id: rootState.service.available.radiusServiceId,
        startDateTime: state.start,
        endDateTime: state.end
      };

      let data = await http.post(`visp/ServiceUsages/${payload.id}`);

      if (data.data !== "") {
        data.data.data.usage.forEach(x => {
          x.output_octets = bytesToGB(x.output_octets, 2, 1024, "GiB");
          x.input_octets = bytesToGB(x.input_octets, 2, 1024, "GiB");
        });

        dispatch("setUsage", data.data.data);
      } else dispatch("setUsage", {});
      dispatch("processLoader/setProcessInactive", {}, { root: true });
    } catch (e) {
      dispatch(
        "httpResponse/setHttpResponse",
        { text: e.message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  setDate({ commit }, data) {
    commit("SET_DATE", data);
  },
  setUsage({ commit }, data) {
    commit("SET_USAGE", data);
  }
};
